import axios from 'axios'
import { url } from '@/api/url'
import { HeadersWithCredentials } from '@/api/header'

export const uploadGoodyImage = async (competitionId, formData) => {
    return await axios.post(`${url}/ticketing/upload-goody-image/${competitionId}`, formData, {
        headers: {
            ...HeadersWithCredentials(),
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const createGoody = async (competitionId, goody) => {
    return await axios.post(`${url}/ticketing/create-goody/${competitionId}`, goody, {
        headers: HeadersWithCredentials(),
    })
}

export const editGoody = async (competitionId, goodyId, goody) => {
    return await axios.patch(`${url}/ticketing/edit-goody/${competitionId}/${goodyId}`, goody, {
        headers: HeadersWithCredentials(),
    })
}

export const deleteGoody = async (competitionId, goodyId) => {
    return axios.delete(`${url}/ticketing/delete-goody/${competitionId}/${goodyId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const findGoodies = async (goodiesIds, competitionId) => {
    return axios.post(
        `${url}/ticketing/find-goodies`,
        { goodiesIds, competitionId },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const findCompetitionWithoutPrivateData = async (eventIdentifier) =>
    axios.get(`${url}/leaderboard/competition/findCompetitionWithoutPrivateData/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })

export const getDivisionsIdsAndNamesAndCountParticipations = async (eventIdentifier) =>
    axios.get(`${url}/leaderboard/competition/getDivisionsIdsAndNamesAndCountParticipations/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })

export const getOrders = async (boardId) => {
    return axios.get(`${url}/ticketing/find-orders/${boardId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const findOrderById = async (orderId) => {
    return axios.get(`${url}/ticketing/find-order-by-id/${orderId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const updateOrder = async (newOrder) => {
    return axios.put(`${url}/orders/update/by-orga/${newOrder.competition_id}`, newOrder, {
        headers: HeadersWithCredentials(),
    })
}

export const updateTicketing = async (ticketingId, data) => {
    return axios.patch(`${url}/ticketing/${ticketingId}`, data, {
        headers: HeadersWithCredentials(),
    })
}

export const isRegistrationOpen = async (competitionId) => {
    return axios.get(`${url}/ticketing/is-open/${competitionId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getUpdatedTicketing = async (competitionId, divisionId, reason) => {
    return axios.put(
        `${url}/ticketing/get-updated-ticketing/${competitionId}`,
        {},
        { headers: HeadersWithCredentials() },
    )
}

export const getParticipantsList = async (competitionId) => {
    return axios.get(`${url}/participants/${competitionId}`)
}

export const IsPublished = async (eventIdentifier) => {
    return await axios.get(`${url}/ticketing/is-published/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}
